import { ActionTypes } from '../actions/types';

const initialState = {
  activeTab: '',
};

export default function (
  state = initialState,
  action: { type: ActionTypes; payload: any }
) {
  const { type, payload } = action;

  switch (type) {
    case ActionTypes.SET_ACTIVE_TAB:
      return {
        ...state,
        activeTab: payload,
      };

    case ActionTypes.GET_ACTIVE_TAB: {
      return {
        ...state,
        activeTab: payload,
      };
    }

    default:
      return state;
  }
}
